import { useState } from 'react';
import Share from '@alltrails/shared/icons/Share';
import { COLOR_BRAND_PRIMARY } from '@alltrails/shared/denali/tokens';
import logTrailDetailsShareButtonTapped from '@alltrails/analytics/events/logTrailDetailsShareButtonTapped';
import useUser from 'hooks/useUser';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import useLanguageCode from 'hooks/useLanguageCode';
import { LanguageSupportUtil } from 'utils/language_support_util';
import { Trail } from 'types/Trails';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { wrapEventHandler } from '../../utils/handlers';
import { renderShareModal } from '../../application/javascripts/react_components/main_action_bar/share_modal';
import ActionBarItem from '../ActionBarItem';
import { modalSignup } from '../../utils/modal_funnel_util';

export type SharePopupButtonProps = {
  className?: string;
  shareObject: unknown;
  trail?: Trail;
  onClick?: () => void;
};

function SharePopupButton({ className, shareObject, trail, onClick }: SharePopupButtonProps): JSX.Element {
  const languageCode = useLanguageCode();
  const languageRegionCode = useLanguageRegionCode();
  const user = useUser();
  const [showShareModal, setShowShareModal] = useState(false);

  function hideShareModal() {
    setShowShareModal(false);
  }

  function handleClick() {
    if (onClick) {
      onClick();
    }

    if (!user) {
      logTrailDetailsShareButtonTapped({ trail_id: trail?.trail_id });
      const returnToUrl = LanguageSupportUtil.wrapUrlSafe(window.location.pathname + window.location.search, languageRegionCode);
      modalSignup('list-action-menu-phone', returnToUrl, languageRegionCode);
      return false;
    }

    setShowShareModal(true);
  }

  return (
    <>
      <ActionBarItem
        onClick={wrapEventHandler(handleClick)}
        icon={<Share color={COLOR_BRAND_PRIMARY} />}
        title={StringConstantsMixin.strings.SHARE}
        className={className}
        testId="share-action"
      />
      {renderShareModal(showShareModal, hideShareModal, shareObject, user, languageRegionCode, languageCode)}
    </>
  );
}

export default SharePopupButton;
